import * as React from "react"

import { cn } from "../../lib/utils"

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  /**
   * Define el tamaño del textarea
   * - sm: 80px de altura mínima
   * - md: 120px de altura mínima (default)
   * - lg: 180px de altura mínima
   * - xl: 240px de altura mínima
   */
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, size = 'md', ...props }, ref) => {
    const sizeClasses = {
      sm: 'min-h-[80px]',
      md: 'min-h-[120px]',
      lg: 'min-h-[180px]',
      xl: 'min-h-[240px]',
    };

    return (
      <textarea
        className={cn(
          "flex w-full rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm transition-colors",
          "text-gray-900 placeholder:text-gray-400",
          "focus:outline-none focus:ring-0 focus:border-[rgb(102,99,255)]",
          "disabled:cursor-not-allowed disabled:opacity-50 disabled:pointer-events-none",
          "dark:bg-neutral-900 dark:border-neutral-700 dark:text-neutral-400 dark:placeholder-neutral-500",
          "resize-none",
          sizeClasses[size],
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Textarea.displayName = "Textarea"

export { Textarea } 